export const stepFourFieldNames = {
  CONFIRMATION_STATUS: 'confirmationStatus',
};

export function withNameSpace(namespace, fieldName ) {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
}
